/* esm.sh - @twind/preset-tailwind@1.1.4/colors */
export * from "/v131/@twind/preset-tailwind@1.1.4/denonext/colors.js";
